import { useApp } from '@/hooks/useApp'
import { type V1AppColorTheme } from 'mnvm-mypage-app-ts-if'
import { useRef, useEffect } from 'react'
import styled from 'styled-components'
import InputErrorLabel from '../InputErrorLabel'

export interface StyledTextareaProps {
  maxWidth?: string
  width?: string
  disabledColor?: string
  disabled?: boolean
  backgroundColor?: V1AppColorTheme
  isAutoResize?: boolean
  borderColor?: V1AppColorTheme
}

const StyledTextarea = styled.textarea<StyledTextareaProps>`
  width: ${({ width }) => (width !== undefined ? width : '100%')};
  max-width: ${({ maxWidth }) => maxWidth};
  background-color: ${({ backgroundColor }) =>
    backgroundColor?.color != null ? backgroundColor.color : 'white'};
  resize: none;
  box-sizing: border-box;
  min-height: 85px;
  max-height: 172px;
  margin: 0px;
  border: 1px solid
    ${({ borderColor }) =>
      borderColor?.color != null ? borderColor.color : '#e0e0e0'};
  resize: ${({ isAutoResize }) =>
    isAutoResize != null && isAutoResize ? 'none' : 'auto'};
  overflow: ${({ isAutoResize }) =>
    isAutoResize != null && isAutoResize ? 'hidden' : 'auto'};
  field-sizing: content;
`
export interface InputTextAreaProps {
  maxWidth?: string
  width?: string
  disabled?: boolean
  disabledColor?: string
  value?: string
  placeholder?: string
  maxLength?: number
  autoResize?: boolean
  errorMessage?: string
  onChange: (value: string) => void
}

const InputTextArea = ({
  maxWidth,
  width,
  disabled,
  value,
  placeholder,
  maxLength,
  autoResize,
  errorMessage,
  onChange
}: InputTextAreaProps): JSX.Element => {
  const app = useApp()
  const backgroundColor =
    disabled ?? false ? app.theme.lightGrayColor : app.theme.transparent

  const isAutoResize = autoResize ?? false
  const textAreaRef = getAutoResizeRef(value)

  return (
    <>
      <StyledTextarea
        placeholder={placeholder}
        value={value}
        onChange={(event) => {
          onChange(event.target.value)
        }}
        maxLength={maxLength}
        disabled={disabled}
        width={width ?? '100%'}
        maxWidth={maxWidth}
        backgroundColor={backgroundColor}
        ref={isAutoResize ? textAreaRef : null}
        isAutoResize={isAutoResize}
        borderColor={
          errorMessage !== undefined
            ? app.theme.errorMainColor
            : app.theme.frameColor
        }
      />
      {errorMessage !== undefined && <InputErrorLabel message={errorMessage} />}
    </>
  )
}

export default InputTextArea

const getAutoResizeRef = (
  value: string | undefined
): React.RefObject<HTMLTextAreaElement> => {
  const ref = useRef<HTMLTextAreaElement>(null)

  useEffect(() => {
    const element = ref.current
    if (element == null) {
      return
    }
    element.style.height = 'auto' // 行数が減った時に高さを調整する
    element.style.height = `${element.scrollHeight}px`
  }, [value])

  return ref
}
